// store custom animation settings here to keep consistent feeling across all components

export const MENU_SELECT_TOGGLE_DURATION = 'duration-200'
export const MENU_TOGGLE_DURATION = 'duration-300'
